export default __webpack_public_path__ + "static/media/5.7d7095b5.webp";